import { canUseDOM } from 'exenv';
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import get from 'lodash/get';
import Slider from 'react-slick';
import Cookies from 'js-cookie';
import ReactJWPlayer from 'react-jw-player';
import AdTagGenerator from './utils/video_module_ads';
import Slug from '../slug/slug';
import Card from '../card/card';
import { slugify } from '../../../utils/string_util';
import log from '../../../services/logger_service';

let scriptjs = false;
let ifvisible = false;

if (canUseDOM) {
  // eslint-disable-next-line global-require
  scriptjs = require('scriptjs');
  // eslint-disable-next-line global-require
  ifvisible = require('ifvisible.js');
}

export default class Video extends Component {
  constructor() {
    super();

    this.state = {
      playingIndex: 0,
      activeTitle: '',
      userIsActive: true,
      firstimp: false
    };

    this.videoCardClick = this.videoCardClick.bind(this);
    this.generatePreRoll = this.generatePreRoll.bind(this);
    this.setMoatTracking = this.setMoatTracking.bind(this);
    this.getVideoImage = this.getVideoImage.bind(this);
    this.getVideoList = this.getVideoList.bind(this);
    this.setNextVideo = this.setNextVideo.bind(this);
    this.onVideoLoad = this.onVideoLoad.bind(this);
    this.generateShareLink = this.generateShareLink.bind(this);
    this.onReady = this.onReady.bind(this);
  }

  componentDidMount() {
    // eslint-disable-next-line react/no-did-mount-set-state
    this.setState({
      settings: {
        arrows: false,
        infinite: false,
        responsive: [
          {
            breakpoint: 1024,
            settings: {
              slidesToShow: 2.3,
              slidesToScroll: 2,
              slide: '.video-slide'
            }
          },
          {
            breakpoint: 100000,
            settings: 'unslick'
          }
        ]
      }
    });

    if (scriptjs) {
      scriptjs(['https://z.moatads.com/jwplayerplugin0938452/moatplugin.js']);
    }

    // Set up activity tracker, 5s = idle
    if (ifvisible) {
      ifvisible.setIdleDuration(5);
      ifvisible.on('idle', () => {
        this.setState({
          userIsActive: false
        });
      });

      ifvisible.on('wakeup', () => {
        this.setState({
          userIsActive: true
        });
      });
    }
  }

  shouldComponentUpdate(nextProps, nextState) {
    const updateSettings = !this.state.settings;
    const updatePlayingIndex =
      this.state.playingIndex !== nextState.playingIndex;
    const updateActiveTitle = this.state.activeTitle !== nextState.activeTitle;

    return updateSettings || updatePlayingIndex || updateActiveTitle;
  }

  componentWillUnmount() {
    if (canUseDOM) {
      if (window.moatjw) {
        window.moatjw.removeAll();
      }

      if (ifvisible) {
        ifvisible.off('idle');
        ifvisible.off('wakeup');
      }
    }
  }

  onVideoLoad(event) {
    this.setState({
      activeTitle: get(event, 'item.title')
    });
  }

  onReady() {
    const { playerid } = this.props;
    const player = window.jwplayer(playerid);

    const caption = player.getMute() ? 1 : 0;
    player.setCurrentCaptions(caption);

    player.on('complete', () => {
      this.setState({
        firstimp: false
      });

      if (!this.state.userIsActive) {
        player.stop();
      }
    });
  }

  getVideoImage(image) {
    if (!image) return '';

    return `https://images.fastcompany.net/image/fetch/w_280,ar_16:9,c_fill,g_auto,q_auto,f_auto,fl_lossy/${image}`;
  }

  getVideoList() {
    const { stories } = this.props;

    return stories.map((video, index) => ({
      id: video.mediaid,
      title: video.title,
      link: video.link,
      featured_image: {
        source: this.getVideoImage(get(video, 'image'))
      },
      isPlayerVideo: true,
      isVideoActive: this.state.playingIndex === index,
      index
    }));
  }

  setMoatTracking(event) {
    if (window.moatjw) {
      window.moatjw.add({
        partnerCode: 'mansuetojwint127635890115',
        player: this.player,
        adImpressionEvent: event
      });
    }
  }

  setNextVideo() {
    const playingIndex = this.state.playingIndex + 1;
    this.setState({ playingIndex });
  }

  generatePreRoll() {
    const { data, type, readTime, pos } = this.props;

    if (!Cookies.get('dailycookie') && !this.state.alreadySawFirstImpression) {
      this.setState({
        firstimp: true,
        alreadySawFirstImpression: true
      });
    }

    return new AdTagGenerator(
      get(data, 'title'),
      type,
      null,
      readTime,
      pos,
      this.state.firstimp
    ).adTag;
  }

  videoCardClick(event, index) {
    const { playerid } = this.props;
    const player = window.jwplayer(playerid);
    const caption = player.getMute() ? 1 : 0;
    this.setState({ playingIndex: index });
    player.playlistItem(index);
    player.setCurrentCaptions(caption);
  }

  generateShareLink(data) {
    return `https://www.fastcompany.com/video/${slugify(
      get(data.playlist[this.state.playingIndex], 'title')
    )}/${get(data.playlist[this.state.playingIndex], 'mediaid')}`;
  }

  renderSlides() {
    const { settings } = this.state;
    const { config } = this.props;
    if (settings) {
      const stories = this.getVideoList();
      return (
        <div className="video-module-playlist">
          <Slider {...settings}>
            {stories.map(item => (
              <div className="video-slide video-slide--vertical" key={item.id}>
                <Card
                  type="video"
                  config={config}
                  metadata={item}
                  cardEvent={this.videoCardClick}
                  hasLink={false}
                />
              </div>
            ))}
          </Slider>
        </div>
      );
    }

    return null;
  }

  render() {
    const { slugName, isPost, data, playerid } = this.props;

    return (
      <section className={`video-row ${isPost ? 'video-row--post' : ''}`}>
        <Slug linkTo="//fastcompany.com/videos" slugName={slugName} />
        <div className="video-module">
          <div className="video-module__player-container">
            <ReactJWPlayer
              playerId={playerid}
              customProps={{
                sharing: {
                  link: this.generateShareLink(data)
                }
              }}
              playerScript={`https://content.jwplatform.com/libraries/${playerid}.js`}
              playlist={`//content.jwplatform.com/feeds/${data.feedid}.json`}
              generatePrerollUrl={this.generatePreRoll}
              onReady={this.onReady}
              playInView={true}
              onAdPlay={this.setMoatTracking}
              onVideoLoad={this.onVideoLoad}
              onOneHundredPercent={this.setNextVideo}
              onError={event => {
                log.error(
                  'Siderail ReactJW Video Player Error',
                  get(event, 'message')
                );
              }}
              onSetupError={event => {
                log.error(
                  'Siderail ReactJW Video Player Error',
                  get(event, 'message')
                );
              }}
              isMuted={true}
              isAutoPlay={false}
              playInViewPercentage={100}
              aspectRatio="16:9"
              useMultiplePlayerScripts={true}
            />
          </div>
          <div className="video-module__title">{this.state.activeTitle}</div>
        </div>
        {this.renderSlides()}
      </section>
    );
  }
}

Video.defaultProps = {
  stories: [],
  data: {},
  slugName: 'Video',
  isPost: false,
  readTime: null,
  type: '',
  pos: ''
};

Video.propTypes = {
  config: PropTypes.shape({}).isRequired,
  stories: PropTypes.arrayOf(PropTypes.shape({})),
  data: PropTypes.shape({}),
  playerid: PropTypes.string.isRequired,
  slugName: PropTypes.string,
  isPost: PropTypes.bool,
  type: PropTypes.string,
  pos: PropTypes.string,
  readTime: PropTypes.string
};
